// Grupos De/Para predefinidos: sempre disponíveis no seletor, mesmo antes de existir algum
// mapeamento. Mesma taxonomia do Mapa de Conciliação (ver WfMatrizRepository.MapEventoParaGrupo),
// mais "Depreciação", que não tem flag próprio no cadastro de eventos.
export const GRUPOS_DEPARA_PREDEFINIDOS = [
  'Cliente/Fornecedor',
  'Somente Cliente',
  'Somente Fornecedor',
  'Tributos',
  'Imobilizado',
  'Depreciação',
  'PL',
  'Empréstimo',
  'Somente Caixa',
  'Somente Banco',
  'Folha de Pagamento',
  'Estoque',
] as const;

/** Predefinidos + grupos já usados na empresa, sem duplicatas e em ordem alfabética. */
export const opcoesDeGrupo = (existentes: string[]): string[] =>
  Array.from(new Set([...GRUPOS_DEPARA_PREDEFINIDOS, ...existentes]))
    .sort((a, b) => a.localeCompare(b, 'pt-BR'));

export const GRUPO_DEPRECIACAO = 'Depreciação';

// Espelha WfClassificacaoContaGrupo.EhContaDeDepreciacao (backend): ignora acentos e caixa.
export const ehContaDeDepreciacao = (descricao?: string | null): boolean =>
  !!descricao && descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes('deprec');
